export default (options) => {
  let ret = options.fn(this);
  return ret.replace(/[\u00A0-\u9999<>&"']/g, function(i) {
    return '&#'+i.charCodeAt(0)+';';
  });
};